import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const actionableContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  position: "relative",
  borderRadius: 8,
  marginTop: 16,
  height: 60,
  padding: "0px 12px",
  background: greys.white,
  boxShadow: `rgba(0, 0, 0, .12) 0 0 2px 0, rgba(0, 0, 0, .24) 0 2px 2px 0`,
  backgroundColor: greys.white,
  transition: "margin-top .4s ease-in-out, transform .6s ease-in-out",
  overflow: "hidden",

  "&:hover": {
    background: greys.palePaleGrey,
    backgroundColor: greys.palePaleGrey,
  },
};

export const container: CSSProperties = {
  ...actionableContainer,
  boxShadow: "none",
  borderStyle: "solid",
  borderWidth: 1,
  borderColor: greys.paleGrey,

  "&:hover": {
    background: "none",
    backgroundColor: "none",
  },
};

export const icon: CSSProperties = {
  color: colors.green.darker,
  width: 20,
  height: 20,
  marginRight: 12,
};

export const basicIcon: CSSProperties = {
  ...icon,
  color: greys.slate,
};

export const errorIcon: CSSProperties = {
  ...icon,
  color: colors.peach.darker,
};

export const status: CSSProperties = {
  display: "flex",
  alignItems: "center",
  color: colors.green.darker,
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: "bold",
};

export const basicStatus: CSSProperties = {
  ...status,
  color: greys.slate,
};

export const errorStatus: CSSProperties = {
  ...status,
  color: colors.peach.darker,
};

export const infoIcon: CSSProperties = {
  marginLeft: 4,
  width: 15,
  height: 15,
  color: greys.cloudyBlue,
};

export const description: CSSProperties = {
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  lineHeight: "20px",
  color: greys.slate,
};

export const errorDescription: CSSProperties = {
  ...description,
  color: colors.peach.darker,
};

export const descriptionIcon: CSSProperties = {
  width: 15,
  height: 15,
};

export const descriptionChevronIcon: CSSProperties = {
  width: 20,
  height: 20,
};

export const popper: CSSProperties = {
  maxWidth: 168,
};

export const styles = {
  actionableContainer,
  container,
  icon,
  basicIcon,
  errorIcon,
  status,
  basicStatus,
  errorStatus,
  infoIcon,
  description,
  errorDescription,
  descriptionIcon,
  descriptionChevronIcon,
  popper,
};
